export default __webpack_public_path__ + "static/media/4cha.21f8d8e4.svg";